import apiClient from "../api/apiClient"

export const EXPENSE_CATEGORIES = ['fuel', 'lunch', 'utilities', 'repair', 'payroll', 'other'] as const
export type ExpenseCategory = typeof EXPENSE_CATEGORIES[number]

export interface Expense {
  _id: string
  company_id: string
  category: ExpenseCategory
  amount: number
  date: string
  description: string
  recorded_by: { _id: string; name: string } | string
  is_deleted: boolean
  createdAt: string
  updatedAt: string
}

export interface ExpenseListResponse {
  info: {
    page: number
    limit: number
    total: number
    totalPages: number
    hasNextPage: boolean
    total_amount: number
  }
  results: Expense[]
}

export interface CreateExpenseForm {
  category: ExpenseCategory
  amount: number
  date: string
  description?: string
  payment_account?: 'cash' | 'bank'
  bank_account_id?: string
}

export const expenseService = {
  async getExpenses(params: { from?: string; to?: string; category?: string; page?: number; limit?: number }): Promise<ExpenseListResponse> {
    const response = await apiClient.get<ExpenseListResponse>('/admin/expenses', { params })
    return response.data
  },

  async createExpense(data: CreateExpenseForm): Promise<Expense> {
    const response = await apiClient.post<{ expense: Expense }>('/admin/expenses', data)
    return response.data.expense
  },

  async deleteExpense(id: string): Promise<void> {
    await apiClient.delete(`/admin/expenses/${id}`)
  },
}
